import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
const store = {
    getters,
    mutations,
    state,
    actions
  };
export default store;


// WEBPACK FOOTER //
// ./src/store/assets/index.js